export var EDateTime;
(function (EDateTime) {
    EDateTime["D_H_M_S"] = "D_H_M_S";
    EDateTime["d_h_m_s"] = "d_h_m_s";
    EDateTime["DD_HH_MM_SS"] = "DD_HH_MM_SS";
    EDateTime["dd_hh_mm_ss"] = "dd_hh_mm_ss";
})(EDateTime || (EDateTime = {}));
